// API URL configuration
const getApiUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    // Use the working Render backend URL
    return 'https://amour-space.onrender.com';
  }
  // In development, use localhost
  return 'http://localhost:5000';
};

const getSocketUrl = () => {
  // In production, use the environment variable or default to the Vercel URL
  if (process.env.NODE_ENV === 'production') {
    // Remove trailing slash if present to avoid double slash issues
    const url = process.env.REACT_APP_SOCKET_URL || 'https://amour-space.onrender.com';
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }
  // In development, use localhost
  return 'http://localhost:5000';
};

export const API_URL = getApiUrl();
export const SOCKET_URL = getSocketUrl(); 